import { OnInit } from '@angular/core';
var NotFoundRouteComponent = /** @class */ (function () {
    function NotFoundRouteComponent() {
    }
    NotFoundRouteComponent.prototype.ngOnInit = function () {
    };
    return NotFoundRouteComponent;
}());
export { NotFoundRouteComponent };
